import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import InfoModal from "../common/InfoModal";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { logUI } from '../../api/andyliticsApi';
import SuccessBanner from './SuccessBanner';
import Spinner from "../common/spinner";
import TryAgainToolTip from '../common/TryAgainToolTip';

class LinkHealthPlanAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            modalText: null,
            modalYesFunction: null,
            modalNoFunction: null
        };
        this.handleUnlinkHealthPlanAccountClick = this.handleUnlinkHealthPlanAccountClick.bind(this);
        this.cancelModel = this.cancelModel.bind(this);
        this.handleUnlinkHealthPlanAccountClick2 = this.handleUnlinkHealthPlanAccountClick2.bind(this);
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.isFromMobile = false;
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
        logUI("MBHWeb.UI.LinkHealthPlanAccount.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    cancelModel() {
        this.setState({ showModal: false });
    }

    handleUnlinkHealthPlanAccountClick() {
        const { HealthPlanID } = this.props;
        if (!HealthPlanID)
            return;
        this.setState({
            showModal: true,
            modalText: <div className="text-center"><p>Are you sure you want to unlink your account?</p><div><p>By unlinking your account, you will be shown the default MyBSWHealth experience with market rates for available services. </p></div><p>You may visit this page at any time to re-link your account.</p></div>,
            modalYesFunction: this.handleUnlinkHealthPlanAccountClick2,
            modalNoFunction: this.cancelModel
        });
    }

    handleUnlinkHealthPlanAccountClick2() {
        const { unlinkHealthPlanAccount, HealthPlanID } = this.props;
        this.cancelModel();
        logUI("MBHWeb.Account.HealthPlan.UnLink", new Date(), Tools.getURLPath());
        unlinkHealthPlanAccount(this.isFromMobile, HealthPlanID);
        window.componentChanged = false;
    }

    clearAllMessages() {
        const { clearUnLinkMessages } = this.props;
        clearUnLinkMessages();
    }


    render() {
        const {
            HealthPlanID,
            linkHP,
            unlinkHP,
            isProxyUser,
            swhpDown
        } = this.props;
        const { showModal,
            modalYesFunction,
            modalNoFunction,
            modalText } = this.state;
        if (isProxyUser) {
            return "";
        }
        return (
            <div className="row">
                <InfoModal isOpen={showModal} className={"linked-accounts-modal"} linkContinueLabel={"YES, UNLINK"} linkCancelLabel={"NO, GO BACK"} modalBody={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />

                <div className="col-12 list-item-col not-linked">
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="list-item-col__label">Baylor Scott & White Health Plan</div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4 text-left text-sm-right text-lg-left">
                            <div className="list-item-col__info">
                                {swhpDown ? HealthPlanID ? <div className="list-item-col__info--linked">{HealthPlanID} <span className="icon-link" /></div>
                                    : <div className="unable-display">Unable to display</div>
                                    : HealthPlanID ? <div className="list-item-col__info--linked">{HealthPlanID} <span className="icon-link" /></div>
                                        : linkHP?.successMessage ? <div className="list-item-col__info--linked">{linkHP.successMessage.indexOf(":") > 0 ? linkHP?.successMessage.slice(linkHP.successMessage.indexOf(":") + 1) : ""}</div>
                                            : null}
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 text-sm-right">
                            {(unlinkHP?.successMessage) ?
                                <Spinner /> :
                                swhpDown && HealthPlanID ?
                                    <React.Fragment>
                                        <button id="healthPlan-link" type="button" className="list-item-col__action btn btn-link-style btn-disabled">Unlink account</button>
                                        <TryAgainToolTip target="healthPlan-link" />
                                    </React.Fragment>
                                    : <button type="button" className="list-item-col__action btn btn-link-style" onClick={(e) => this.handleUnlinkHealthPlanAccountClick()}>Unlink account</button>
                            }
                        </div>
                        {unlinkHP?.error &&
                            <div className="col-12">
                                <div className="error-msg">{unlinkHP.error}</div>
                            </div>}
                    </div>
                    <SuccessBanner showMessage={!this.isFromMobile && linkHP?.successMessage} message={linkHP?.successMessage} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        HealthPlanID: state.memberships.anySWHPMembershipId,
        linkHP: state.healthPlan.linkHP,
        unlinkHP: state.healthPlan.unlinkHP,
        isProxyUser: state.domain.ip,
        serverData: state.session.serverData,
        MobileOnQueryString: state.domain.mq,
        swhpDown: state.common.swhpDown
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        unlinkHealthPlanAccount: (isFromMobile, MemberId) => {
            dispatch({
                type: types.UNLINK_HEALTHPLAN_ACCOUNT,
                isFromMobile,
                MemberId
            });
        },
        clearUnLinkMessages: () => dispatch({
            type: types.UNLINK_HEALTHPLAN_CLEAR_MESSAGE
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkHealthPlanAccount);